import { useEffect, useRef, useState } from "react";
import PhotoViewer from "@/components/community/PhotoViewer";

const PHOTOS = [
  { src: "/images/mbs-fleet-dock.webp", alt: "MBS Transit box trucks at the loading dock" },
  { src: "/images/mbs-fleet-row.webp", alt: "Row of MBS Transit Global Logistics trucks" },
];

function FitLine({ children }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    const fit = () => {
      let size = 18;
      el.style.fontSize = `${size}px`;
      while (el.scrollWidth > el.clientWidth && size > 8) {
        size -= 0.5;
        el.style.fontSize = `${size}px`;
      }
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el.parentElement);
    return () => ro.disconnect();
  }, []);
  return (
    <p ref={ref} className="col-span-2 whitespace-nowrap overflow-hidden font-heading font-bold leading-tight text-white" data-testid="community-fleet-caption">
      {children}
    </p>
  );
}

export default function FleetPhotos() {
  const [view, setView] = useState(null);
  return (
    <div className="pin-photos z-20 bg-background -mx-4 sm:-mx-6 px-4 sm:px-6 py-2 sm:py-3 mb-4 grid grid-cols-2 gap-2 sm:gap-4" data-testid="community-fleet-photos">
      <FitLine>
        <span className="text-[#F0525F]">&ldquo;MBS Transit fleet&rdquo;.</span> Let&rsquo;s grow your fleet with <span className="text-[#FFD600]">CarrierLaunch</span>.
      </FitLine>
      {PHOTOS.map((p, i) => (
        <button key={p.src} type="button" onClick={() => setView(i)} aria-label={`View full screen: ${p.alt}`} data-testid={`community-fleet-photo-open-${i + 1}`}
          className="group relative overflow-hidden rounded-xl border border-[#262626] hover:border-[#FFD600] focus-visible:border-[#FFD600] focus:outline-none aspect-[16/9] sm:aspect-[3/1] lg:aspect-[7/2] bg-[#141414] cursor-zoom-in transition-colors">
          <img src={p.src} alt={p.alt} loading="eager" draggable={false} data-testid={`community-fleet-photo-${i + 1}`}
            className="absolute inset-0 w-full h-full object-cover select-none pointer-events-none transition-transform duration-300 group-hover:scale-[1.03]" />
        </button>
      ))}
      <PhotoViewer photos={PHOTOS} index={view} onIndex={setView} />
    </div>
  );
}
